import knex, { type Knex } from 'knex'

export type { Knex }

/**
 * Creates a Knex instance with SQLite :memory: for integration tests.
 * Plugins should use this instead of importing knex/better-sqlite3 directly.
 */
export function createTestDb(): Knex {
  return knex({
    client: 'better-sqlite3',
    connection: ':memory:',
    useNullAsDefault: true
  })
}
